import * as React from 'react';
export const iosShareSvg = React.forwardRef(function iosShareSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 7.75a.25.25 0 0 0-.25.25v6.25c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25V8a.25.25 0 0 0-.25-.25h-1a.75.75 0 0 1 0-1.5h1c.966 0 1.75.784 1.75 1.75v6.25A1.75 1.75 0 0 1 12 16H4a1.75 1.75 0 0 1-1.75-1.75V8c0-.966.784-1.75 1.75-1.75h1a.75.75 0 0 1 0 1.5H4Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.507.197a.75.75 0 0 0-1.014 0l-3 2.75a.75.75 0 1 0 1.014 1.106L7.25 2.455V10.5a.75.75 0 0 0 1.5 0V2.455l1.743 1.598a.75.75 0 0 0 1.014-1.106l-3-2.75Z',
    }),
  );
});
iosShareSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var iosShare = {
  category: 'icon',
  colorable: true,
  name: 'iosShare',
  svg: iosShareSvg,
};
